<template>
    <div id="app">
        <div class="x-dialog">
            <div class="dialog-mask"></div>
            <div class="dialog">
                <div class="dialog-content">
                    <a href="http://priorityh5.zhaoonline.com/activity/html/2019/06/18-introduction-web.html">
                        <img class="dialog-img" src="./assets/img/download_dialog.jpg">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'App',
    components: {}
}
</script>
<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-size: 14px;
    color: #444;
    line-height: 1.5;
}

.x-dialog .dialog-mask {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
}

.x-dialog .dialog {
    position: fixed;
    display: table;
    z-index: 5000;
    width: 80%;
    max-width: 18.75rem;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    background-color: #fff;
    text-align: center;
    overflow: hidden;
}

.dialog .dialog-content {
    width: 100%;
    background-color: #fff;
    position: relative;
}

.dialog .dialog-img {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
}
</style>